import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const res = await register({
      ...form,
      email: form.email.trim().toLowerCase(),
      role: "patient",
    });
    setBusy(false);
    if (!res.ok) {
      setErr(res.error);
      toast.error(res.error);
      return;
    }
    toast.success("Account created. Welcome!");
    navigate("/portal", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col" style={{ fontFamily: "Manrope, sans-serif" }}>
      <header className="bg-white border-b border-zinc-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/"><Logo size={44} withText /></Link>
          <Link to="/login" className="text-sm font-semibold underline underline-offset-2" data-testid="goto-login">
            I already have an account
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-lg bg-white border border-zinc-200 rounded-sm p-6 sm:p-8">
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-2">Patient sign-up</div>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tighter text-zinc-900 mb-2" style={{ fontFamily: "Manrope, sans-serif" }}>
            Create your patient portal.
          </h1>
          <p className="text-sm text-zinc-500 mb-6">Book appointments, view your treatment history and invoices anytime.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <Field label="Full name" testid="reg-name">
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full border border-zinc-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-zinc-900"
                placeholder="Your full name" data-testid="register-name"/>
            </Field>
            <Field label="Email" testid="reg-email">
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full border border-zinc-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-zinc-900"
                placeholder="you@email.com" data-testid="register-email"/>
            </Field>
            <Field label="Phone (optional)" testid="reg-phone">
              <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="w-full border border-zinc-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-zinc-900"
                placeholder="+91 â€¦" data-testid="register-phone"/>
            </Field>
            <Field label="Password" testid="reg-password">
              <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full border border-zinc-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-zinc-900"
                placeholder="At least 6 characters" data-testid="register-password"/>
            </Field>

            {err && <div className="text-sm text-[#E60000] border border-red-200 bg-red-50 px-3 py-2 rounded-sm">{err}</div>}

            <button type="submit" disabled={busy}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#E60000] hover:bg-[#CC0000] text-white font-semibold rounded-sm px-6 py-3 disabled:opacity-60"
              data-testid="register-submit">
              {busy ? "Creatingâ€¦" : "Create my account"} <ArrowRight size={16} weight="bold" />
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700">{label}</label>
      <div className="mt-2">{children}</div>
    </div>
  );
}
